"use strict";

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

(function () {
  "use strict";

  angular.module("users").controller("UsersCtrl.bulk", Ctrl);

  function Ctrl(vm, $rootScope, $timeout, UsersService, GroupsService, CustomListsService, CustomersService, FormlyService) {
    var _this = this;

    var service = UsersService;

    vm.nbCheckbox = 0;

    vm.countCheckBox = function () {
      console.log("countCheckBox");
      var count = 0;
      for (var index = 0; index < vm.rawData.length; index++) {
        if (vm.rawData[index].checkbox == true) {
          count++;
        }
      }

      vm.nbCheckbox = count;
    };

    vm.endDateToApply = new Date(); // Default case

    vm.onEndDateToApply = function (value) {
      vm.endDateToApply = value;
    };

    vm.endBlockDateToApply = new Date();

    vm.onEndBlockDateToApply = function (value) {
      vm.endBlockDateToApply = value;
    };

    vm.actionChange = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var allVehicles, customerVehicles, groupsCase4, groupsCase5, positions;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log("action change", vm.action);

              _context.t0 = vm.action;
              _context.next = _context.t0 === "1" ? 4 : _context.t0 === "2" ? 4 : _context.t0 === "37" ? 8 : _context.t0 === "38" ? 8 : _context.t0 === "4" ? 16 : _context.t0 === "5" ? 21 : _context.t0 === "21" ? 26 : _context.t0 === "22" ? 28 : _context.t0 === "3" ? 28 : _context.t0 === "7" ? 28 : _context.t0 === "8" ? 28 : _context.t0 === "9" ? 28 : _context.t0 === "11" ? 28 : _context.t0 === "12" ? 28 : _context.t0 === "13" ? 28 : _context.t0 === "14" ? 28 : 49;
              break;

            case 4:
              _context.next = 6;
              return UsersService.getPositionArray($rootScope.$selectedCustomerId);

            case 6:
              vm.allPositions = _context.sent;
              return _context.abrupt("break", 49);

            case 8:
              _context.next = 10;
              return CustomListsService.getSelectArray("typeVehicleV2");

            case 10:
              allVehicles = _context.sent;
              _context.next = 13;
              return CustomersService.getById($rootScope.$selectedCustomerId);

            case 13:
              customerVehicles = _context.sent;

              vm.allVehicles = allVehicles.filter(function (vehicle) {
                return !customerVehicles.fleetTypes || !customerVehicles.fleetTypes.length || customerVehicles.fleetTypes.includes(vehicle.value);
              });
              return _context.abrupt("break", 49);

            case 16:
              _context.next = 18;
              return GroupsService.getSelectArray();

            case 18:
              groupsCase4 = _context.sent;

              vm.groupsArray = groupsCase4;
              return _context.abrupt("break", 49);

            case 21:
              _context.next = 23;
              return GroupsService.getSelectArray(true);

            case 23:
              groupsCase5 = _context.sent;

              vm.groupsArray = groupsCase5;
              return _context.abrupt("break", 49);

            case 26:
              vm.allFields = [{ value: "positionTitle", name: "Titre" }, { value: "note", name: "Commentaires" }, { value: "email", name: "Email" }, { value: "cellularPhone", name: "Portable" }, { value: "phone", name: "Téléphone" }, { value: "contract", name: "Contrat" }, { value: "externalCompany", name: "Société d'intérim" }, { value: "areaName", name: "Zone de travail" }, { value: "departmentName", name: "Département" }, { value: "defaultManagerId", name: vm.defaultManagerLabel }, { value: "rhManagerId", name: vm.rhManagerLabel }, { value: "fleetManagerId", name: vm.fleetManagerLabel }, { value: "qseManagerId", name: vm.qseManagerLabel }, { value: "other1ManagerId", name: vm.other1ManagerLabel }, { value: "other2ManagerId", name: vm.other2ManagerLabel }, { value: "yearOfBirth", name: "Année de naissance" }, { value: "licenceValidityDate", name: "Date validité permis" }, { value: "startDate", name: "Date d'embauche" }, { value: "endDate", name: "Date de sortie" }, {
                value: "endBlockDate",
                name: "Date de fin d'arrêt (congé, maladie, etc.)"
              }, { value: "isVirtual", name: "Collaborateur virtuel" }, {
                value: "isVisibleByEveryone",
                name: "Conducteur visible par tout le monde"
              }];
              return _context.abrupt("break", 49);

            case 28:
              _context.next = 30;
              return UsersService.getPositionArray($rootScope.$selectedCustomerId);

            case 30:
              positions = _context.sent;
              _context.next = 33;
              return UsersService.remoteSelectArray(positions.map(function (position) {
                if (position.value != "Conducteur") {
                  return position.value;
                }
              }));

            case 33:
              vm.allUsersNotDriver = _context.sent;


              vm.allUsersNotDriver = vm.allUsersNotDriver.filter(function (element) {
                return element.value !== "$";
              });
              vm.allUsersNotDriver.unshift({ value: "", name: "Aucun" });

              vm.allManagers = vm.allUsersNotDriver.filter(function (element) {
                return element.name.indexOf($rootScope.defaultManagerLabel) > -1;
              });
              vm.allManagers.unshift({ value: "", name: "Aucun" });

              vm.allRHManagers = vm.allUsersNotDriver.filter(function (element) {
                return element.name.indexOf($rootScope.rhManagerLabel) > -1;
              });
              vm.allRHManagers.unshift({ value: "", name: "Aucun" });

              vm.allFleetManagers = vm.allUsersNotDriver.filter(function (element) {
                return element.name.indexOf($rootScope.fleetManagerLabel) > -1;
              });
              vm.allFleetManagers.unshift({ value: "", name: "Aucun" });

              vm.allQseManagers = vm.allUsersNotDriver.filter(function (element) {
                return element.name.indexOf($rootScope.qseManagerLabel) > -1;
              });
              vm.allQseManagers.unshift({ value: "", name: "Aucun" });

              vm.allOther1Managers = vm.allUsersNotDriver.filter(function (element) {
                return element.name.indexOf($rootScope.other1ManagerLabel) > -1;
              });
              vm.allOther1Managers.unshift({ value: "", name: "Aucun" });

              vm.allOther2Managers = vm.allUsersNotDriver.filter(function (element) {
                return element.name.indexOf($rootScope.other2ManagerLabel) > -1;
              });
              vm.allOther2Managers.unshift({ value: "", name: "Aucun" });

              return _context.abrupt("break", 49);

            case 49:

              $timeout(function () {}, 10);

            case 50:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    vm.updateAll = function () {
      switch (vm.action) {
        case "1":
          vm.update({
            dataList: [{
              filters: { _id: { $in: vm.getSelectedId() } },
              vals: {
                $addToSet: {
                  positions: vm.positionToApply
                }
              }
            }]
          });
          break;
        case "2":
          vm.update({
            dataList: [{
              filters: { _id: { $in: vm.getSelectedId() } },
              vals: {
                $pull: {
                  positions: vm.positionToApply
                }
              }
            }]
          });
          break;

        case "37":
          vm.update({
            dataList: [{
              filters: { _id: { $in: vm.getSelectedId() } },
              vals: {
                $addToSet: {
                  typeVehicles: vm.typeVehiclesToApply
                }
              }
            }]
          });
          break;
        case "38":
          vm.update({
            dataList: [{
              filters: { _id: { $in: vm.getSelectedId() } },
              vals: {
                $pull: {
                  typeVehicles: vm.typeVehiclesToApply
                }
              }
            }]
          });
          break;

        case "3":
          vm.update({
            dataList: [{
              filters: { _id: { $in: vm.getSelectedId() } },
              vals: {
                defaultManagerId: vm.managerToApply === "" ? null : vm.managerToApply
              }
            }]
          });
          break;

        case "9":
          vm.update({
            dataList: [{
              filters: { _id: { $in: vm.getSelectedId() } },
              vals: {
                rhManagerId: vm.managerToApply === "" ? null : vm.managerToApply
              }
            }]
          });
          break;

        case "11":
          vm.update({
            dataList: [{
              filters: { _id: { $in: vm.getSelectedId() } },
              vals: {
                fleetManagerId: vm.managerToApply === "" ? null : vm.managerToApply
              }
            }]
          });
          break;

        case "12":
          vm.update({
            dataList: [{
              filters: { _id: { $in: vm.getSelectedId() } },
              vals: {
                qseManagerId: vm.managerToApply === "" ? null : vm.managerToApply
              }
            }]
          });

          break;

        case "13":
          vm.update({
            dataList: [{
              filters: { _id: { $in: vm.getSelectedId() } },
              vals: {
                other1ManagerId: vm.managerToApply === "" ? null : vm.managerToApply
              }
            }]
          });
          break;

        case "14":
          vm.update({
            dataList: [{
              filters: { _id: { $in: vm.getSelectedId() } },
              vals: {
                other2ManagerId: vm.managerToApply === "" ? null : vm.managerToApply
              }
            }]
          });
          break;

        case "4":
          vm.update({
            dataList: [{
              filters: { _id: { $in: vm.getSelectedId() } },
              vals: {
                $addToSet: {
                  groupsId: vm.groupIdToApply
                }
              }
            }]
          });
          break;

        case "5":
          vm.update({
            dataList: [{
              filters: { _id: { $in: vm.getSelectedId() } },
              vals: {
                $pull: {
                  groupsId: vm.groupIdToApply
                }
              }
            }]
          });
          break;

        case "6":
          vm.update({
            dataList: [{
              filters: { _id: { $in: vm.getSelectedId() } },
              vals: {
                rights: vm.rights.rights,
                role: vm.rights.role
              }
            }]
          });
          break;

        case "7":
          vm.update({
            dataList: [{
              filters: { _id: { $in: vm.getSelectedId() } },
              vals: {
                $addToSet: {
                  usersEmailsCcId: vm.userToApply
                }
              }
            }]
          });
          break;

        case "8":
          vm.update({
            dataList: [{
              filters: { _id: { $in: vm.getSelectedId() } },
              vals: {
                $pull: {
                  usersEmailsCcId: vm.userToApply
                }
              }
            }]
          });
          break;

        case "10":
          vm.deleteIds(vm.getSelectedId());
          break;

        case "20":
          Notiflix.Confirm.show("Date de sortie", "Une fois la date de sortie dépassée, l'email, et les numéros de téléphone des collaborateurs seront supprimés.", "Confirmer", "Annuler", function () {
            vm.update({
              dataList: [{
                filters: { _id: { $in: vm.getSelectedId() } },
                vals: {
                  endDate: vm.endDateToApply
                }
              }]
            });
          }, function () {
            return;
          });
          break;

        case "21":
          var vals = {};
          vals[vm.fieldToUnset] = null;

          vm.update({
            dataList: [{
              filters: { _id: { $in: vm.getSelectedId() } },
              vals: vals
            }]
          });
          break;

        case "36":
          vm.update({
            dataList: [{
              filters: { _id: { $in: vm.getSelectedId() } },
              vals: {
                endBlockDate: vm.endBlockDateToApply
              }
            }]
          });
          break;

        case "22":
          vm.update({
            dataList: [{
              filters: { _id: { $in: vm.getSelectedId() } },
              vals: {
                isVirtual: true
              }
            }]
          });

        case "23":
          vm.update({
            dataList: [{
              filters: { _id: { $in: vm.getSelectedId() } },
              vals: {
                toCheck: false
              }
            }]
          });

          break;

        case "24":
          vm.update({
            dataList: [{
              filters: { _id: { $in: vm.getSelectedId() } },
              vals: {
                defaultManagerIdIsAutoFilled: true
              }
            }]
          });
          break;

        case "25":
          vm.update({
            dataList: [{
              filters: { _id: { $in: vm.getSelectedId() } },
              vals: {
                rhManagerIdIsAutoFilled: true
              }
            }]
          });
          break;

        case "26":
          vm.update({
            dataList: [{
              filters: { _id: { $in: vm.getSelectedId() } },
              vals: {
                fleetManagerIdIsAutoFilled: true
              }
            }]
          });
          break;

        case "27":
          vm.update({
            dataList: [{
              filters: { _id: { $in: vm.getSelectedId() } },
              vals: {
                qseManagerIdIsAutoFilled: true
              }
            }]
          });
          break;

        case "28":
          vm.update({
            dataList: [{
              filters: { _id: { $in: vm.getSelectedId() } },
              vals: {
                other1ManagerIdIsAutoFilled: true
              }
            }]
          });
          break;

        case "29":
          vm.update({
            dataList: [{
              filters: { _id: { $in: vm.getSelectedId() } },
              vals: {
                other2ManagerIdIsAutoFilled: true
              }
            }]
          });
          break;

        case "30":
          vm.update({
            dataList: [{
              filters: { _id: { $in: vm.getSelectedId() } },
              vals: {
                defaultManagerIdIsAutoFilled: false
              }
            }]
          });
          break;

        case "31":
          vm.update({
            dataList: [{
              filters: { _id: { $in: vm.getSelectedId() } },
              vals: {
                rhManagerIdIsAutoFilled: false
              }
            }]
          });
          break;

        case "32":
          vm.update({
            dataList: [{
              filters: { _id: { $in: vm.getSelectedId() } },
              vals: {
                fleetManagerIdIsAutoFilled: false
              }
            }]
          });
          break;

        case "33":
          vm.update({
            dataList: [{
              filters: { _id: { $in: vm.getSelectedId() } },
              vals: {
                qseManagerIdIsAutoFilled: false
              }
            }]
          });
          break;

        case "34":
          vm.update({
            dataList: [{
              filters: { _id: { $in: vm.getSelectedId() } },
              vals: {
                other1ManagerIdIsAutoFilled: false
              }
            }]
          });
          break;

        case "35":
          vm.update({
            dataList: [{
              filters: { _id: { $in: vm.getSelectedId() } },
              vals: {
                other2ManagerIdIsAutoFilled: false
              }
            }]
          });
          break;
      }
    };

    vm.changeSelection = function (value) {
      for (var index = 0; index < vm.rawData.length; index++) {
        vm.rawData[index].checkbox = value;
      }

      console.log("call countCheckBox");

      vm.countCheckBox();
    };

    vm.getSelectedId = function () {
      var idList = [];

      console.log("vm.rowsSelected", vm.rowsSelected);

      for (var index = 0; index < vm.rowsSelected.length; index++) {
        idList.push(vm.rowsSelected[index].data._id);
      }

      console.log("getSelectedId", idList);
      return idList;
    };

    vm.update = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(data) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                Notiflix.Loading.standard("Cliquez pour interrompre le chargement...");
                _context2.prev = 1;
                _context2.next = 4;
                return UsersService.customPatch("update", data);

              case 4:
                _context2.next = 10;
                break;

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2["catch"](1);

                // Show error
                Notiflix.Notify.failure("Erreur lors de la mise à jour");
                console.error(_context2.t0);

              case 10:
                Notiflix.Loading.remove();
                vm.refresh();

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this, [[1, 6]]);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    vm.deleteIds = function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(ids) {
        var confirm, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _id;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return swal({
                  title: "Voulez-vous vraiment supprimer " + ids.length + " collaborateur(s) ?",
                  icon: "warning",
                  dangerMode: true,
                  buttons: {
                    cancel: "Non",
                    confirm: "Oui"
                  }
                });

              case 2:
                confirm = _context3.sent;

                if (!confirm) {
                  _context3.next = 39;
                  break;
                }

                Notiflix.Loading.standard("Cliquez pour interrompre le chargement...");
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context3.prev = 8;
                _iterator = ids[Symbol.iterator]();

              case 10:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context3.next = 23;
                  break;
                }

                _id = _step.value;
                _context3.prev = 12;
                _context3.next = 15;
                return service.deleteById(_id);

              case 15:
                _context3.next = 20;
                break;

              case 17:
                _context3.prev = 17;
                _context3.t0 = _context3["catch"](12);

                console.error(_context3.t0);

              case 20:
                _iteratorNormalCompletion = true;
                _context3.next = 10;
                break;

              case 23:
                _context3.next = 29;
                break;

              case 25:
                _context3.prev = 25;
                _context3.t1 = _context3["catch"](8);
                _didIteratorError = true;
                _iteratorError = _context3.t1;

              case 29:
                _context3.prev = 29;
                _context3.prev = 30;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 32:
                _context3.prev = 32;

                if (!_didIteratorError) {
                  _context3.next = 35;
                  break;
                }

                throw _iteratorError;

              case 35:
                return _context3.finish(32);

              case 36:
                return _context3.finish(29);

              case 37:
                Notiflix.Loading.remove();
                vm.refresh();

              case 39:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this, [[8, 25, 29, 37], [12, 17], [30,, 32, 36]]);
      }));

      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }();

    vm.getRightsFields = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var fields;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.t0 = FormlyService;
              _context4.next = 3;
              return CustomListsService.getSelectArray("roles");

            case 3:
              _context4.t1 = _context4.sent;
              _context4.t2 = _context4.t0.list.call(_context4.t0, "role", "Privilège", _context4.t1);
              fields = [_context4.t2];

              if ($rootScope.$selectedCustomerId !== "$592e962acef2545fb62f1a99") {
                fields = [].concat(_toConsumableArray(fields), [{
                  template: "<b class='text-primary'>Menus Collaborateurs et Véhicules</b><hr/>"
                }, FormlyService.line([FormlyService.bool("rights.resource.read", "Accès aux menus", false, {
                  className: "col-xs-12 col-sm-3"
                }), FormlyService.bool("rights.resource.write", "Boutons ''Créer/Modifier''", false, {
                  className: "col-xs-12 col-sm-3"
                }), FormlyService.bool("rights.resource.delete", "Bouton ''Supprimer''", false, {
                  className: "col-xs-12 col-sm-3"
                })]), { template: "<b class='text-primary'>Menu Sinistres</b><hr/>" }, FormlyService.line([FormlyService.bool("rights.damage.read", "Accès au menu", false, {
                  className: "col-xs-12 col-sm-3"
                }), FormlyService.bool("rights.damage.write", "Boutons ''Créer/Modifier''", false, {
                  className: "col-xs-12 col-sm-3"
                }), FormlyService.bool("rights.damage.send", "Bouton ''Transmettre''", false, {
                  className: "col-xs-12 col-sm-3"
                }), FormlyService.bool("rights.damage.delete", "Bouton ''Supprimer''", false, {
                  className: "col-xs-12 col-sm-3"
                })]), { template: "<b class='text-primary'>Menu Depa</b><hr/>" }, FormlyService.line([FormlyService.bool("rights.depa.read", "Accès au menu", false, {
                  className: "col-xs-12 col-sm-3"
                }), FormlyService.bool("rights.depa.write", "Boutons ''Gérer le RDV''", false, {
                  className: "col-xs-12 col-sm-3"
                })]), { template: "<b class='text-primary'>Menu Formations</b><hr/>" }, FormlyService.line([FormlyService.bool("rights.course.read", "Accès au menu", false, {
                  className: "col-xs-12 col-sm-3"
                }), FormlyService.bool("rights.course.write", "Boutons ''Créer/Modifier''", false, {
                  className: "col-xs-12 col-sm-3"
                }), FormlyService.bool("rights.course.delete", "Bouton ''Supprimer''", false, {
                  className: "col-xs-12 col-sm-3"
                })])]);
              }
              return _context4.abrupt("return", fields);

            case 8:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this);
    }));
  }
})();